// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import pxToRem from "assets/theme/functions/pxToRem";

function DataTableBodyCell({ align, children, isSticky, index, color, style, isChildRow, width }) {
  const leftOffsets = [0, 198, 396];
  const compactRowPaddingY = pxToRem(4); // Reduce body cell vertical padding
  const compactRowPaddingX = pxToRem(10); // Match body cell horizontal padding with header
  const compactRowHeight = pxToRem(32); // Shorter row height for denser table
  const compactBodyFontSize = pxToRem(12); // Slightly smaller body font keeps data readable
  return (
    <MDBox
      component="td"
      textAlign={align}
      width={width || (!isSticky && "141px")}
      sx={({ borders: { borderWidth } }) => ({
        // Compact row spacing keeps tracker rows slimmer
        paddingTop: compactRowPaddingY,
        paddingBottom: compactRowPaddingY,
        paddingLeft: compactRowPaddingX,
        paddingRight: compactRowPaddingX,
        fontSize: compactBodyFontSize,
        borderBottom: !isSticky && isChildRow ? "none" : `${borderWidth[1]} solid #E0E6F5`, // Remove bottom border
        borderTop: !isSticky && isChildRow ? "none" : `${borderWidth[1]} solid #E0E6F5`, // Remove top border
        borderRight: !isSticky && `${borderWidth[1]} solid #E0E6F5`,
        background: isSticky ? "#ffffff" : color !== "" && color,
        position: isSticky ? "sticky" : "static", // Change position to sticky or static
        left: isSticky ? leftOffsets[index - 1] : "auto",
        zIndex: isSticky ? 10 : "auto",
        boxShadow: isSticky && `inset -${borderWidth[1]} 1px 1px #E0E6F5`,
        height: compactRowHeight,
      })}
      {...(Object.keys(style).length > 0 && { style })}
    >
      <MDBox display="inline-block" width="100%" color="text" sx={{ verticalAlign: "middle" }}>
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  align: "left",
  isSticky: false,
  index: 0,
  color: "",
  style: {},
  isChildRow: false,
  children: null,
  width: "",
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node,
  align: PropTypes.oneOf(["left", "right", "center"]),
  isSticky: PropTypes.bool,
  index: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  isChildRow: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DataTableBodyCell;
